import axios from 'axios';

// Set the base URL for the Axios instance
axios.defaults.baseURL = process.env.NEXT_PUBLIC_SERVER_URL;


export default axios;